<template>
  <div>
    <g-master name="detalle_candidato"
              :endpoint="detalleCandidato.endpoint"
              :tableSetup="detalleCandidato.tableSetup"
              :parentData="requestData"
              :key="key"
              :actions="detalleCandidato.actions"
              @action="masterAction"
              @selectAll="selectAll"
              ref="masterComponent">
      <template slot="progresoSlot" slot-scope="{text, record}">
        <a-progress :percent="parseInt(record.calificacion_proceso)" status="active"/>
      </template>
      <span slot="notasSlot" slot-scope="{text}">
            <a-tag :color="text==='VETO' ? 'red' : 'blue'">{{text?text:'N/D'}}</a-tag>
          </span>
      <span slot="estadoRenderer" slot-scope="{text}">
                        <a-tag
                          :color="text==='CONTRATADO' || text==='ASCENSO' ? 'green' : (text === 'APLICA' || text === 'PENDIENTE CONFIRMACIÓN INGRESO' ? 'blue' : 'red')">{{text}}</a-tag>
                    </span>
    </g-master>
    <a-modal title="Registrar Candidato"
             :visible="candidatoModal.visible"
             @ok="confirmarModalRegistrar"
             :confirmLoading="candidatoModal.loading"
             @cancel="cancelModalRegistrar"
             width="90%"
             style="top: 20px;">
      <a-form :form="candidatoModal.form">
        <g-lookup :label="$t('Candidato')"
                  :formItemConfig="candidatoModal.fiOptions"
                  endpoint="personas"
                  :disabled="isedit"
                  :decorator="['id_person', { rules: [{ required: true, message: 'Valor requerido' }]}]"
                  ref="empDropdown">
        </g-lookup>
        <a-form-item v-if="$getConfigValue('REQ_EDITAR_FECHA_INICIO_REG_CANDIDATO', 'NO') === 'SI'"
                     v-bind="candidatoModal.fiOptions" label="Fecha Inicio Labores">
          <a-date-picker style="width: 100%"
                         valueFormat="Y-MM-DD"
                         v-decorator="['initial_date', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
        </a-form-item>
        <g-dropdown :label="$t('Estado')"
                    :formItemConfig="candidatoModal.fiOptions"
                    endpoint="hierarchy_lookup"
                    :decorator="['status', { rules: [{ required: false, message: 'Valor requerido' }]}]"
                    :params="candidatoModal.estado_request">
        </g-dropdown>
        <a-form-item v-bind="candidatoModal.fiOptions" :has-feedback="false" label="Reingreso">
          <a-checkbox v-decorator="['reingreso_check', {valuePropName: 'checked'}]">
          </a-checkbox>
        </a-form-item>
        <a-form-item v-bind="candidatoModal.fiOptions" label="Observaciones">
          <a-textarea
            autoSize
            v-decorator="['observacion']">
          </a-textarea>
        </a-form-item>
        <a-alert type="error" :message="candidatoModal.mensajeError" v-if="candidatoModal.error"/>
      </a-form>
    </a-modal>
    <modal-cargar-candidatos-requisicion v-on:isreloadData="reloadData" :visible="modalCargarCandidatosVisible"
                                         :idRequisicion="requisicion.req_id"
                                         @ok="() => {modalCargarCandidatosVisible = false}"></modal-cargar-candidatos-requisicion>
    <template v-for="msg in messages">
      <p class="scroll-text">
        <a-alert :message="msg.message" :type="msg.type" show-icon closable/>
        <br>
      </p>
    </template>

    <a-tabs v-if="id_person_reg" defaultActiveKey="1">
      <a-tab-pane :tab="'EVALUADORES DE ' + nombre_evaluado + ' ' + id_person" key="1">
        <person-requisition-evaluator :id_person_reg="id_person_reg"></person-requisition-evaluator>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import UserUtil from 'CustomModules/GlobalBPOCore/Util/UserUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        mensaje1: '¿Está seguro que desea continuar?, Este proceso es complejo de reversar.',
        isedit: false,
        modalCargarCandidatosVisible: false,
        candidatoSeleccionado: {},
        id_person_reg: null,
        nombre_evaluado: null,
        id_person: null,
        detalleCandidato: {
          endpoint: 'gestion_humana/persona_requisiciones',
          tableSetup: {
            allowSelect: true,
            selectType: 'checkbox',
            selectedRows: [],
            columns: [
              {title: 'Identificacion', dataIndex: 'id_person', sorter: true},
              {title: 'Nombre', dataIndex: 'name', sorter: true},
              {title: 'Reingreso', dataIndex: 'reingreso_desc', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'estado',
                sorter: true,
                scopedSlots: {
                  customRender: 'estadoRenderer'
                }
              },
              {title: 'Observacion', dataIndex: 'observacion', sorter: true},
              {title: this.$t('Fecha Inicio'), dataIndex: 'fecha_inicio', sorter: true},
              {
                title: 'Calificación Proc.',
                dataIndex: 'calificacion_proceso',
                sorter: true,
                scopedSlots: {customRender: 'progresoSlot', filterDropdown: 'filterDropdown', filterIcon: 'filterIcon'}
              },
              {
                title: 'Notas',
                dataIndex: 'notas',
                sorter: true,
                scopedSlots: {customRender: 'notasSlot', filterDropdown: 'filterDropdown', filterIcon: 'filterIcon'}
              },
              {title: 'Creado Por.', dataIndex: 'created_by', sorter: true},
              {title: 'Creado En.', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado Por.', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado En.', dataIndex: 'modified_on', sorter: true}
            ],
            actions: {
              width: 180,
              scopedSlots: {customRender: 'hooverableAction'},
              actions: [
                {
                  name: 'modificar',
                  text: 'Modificar',
                  icon: 'check',
                  props: {size: 'small', type: 'link', icon: 'edit', style: 'color:blue;'},
                  fnVisible: (record) => {
                    return this.requisicion.estado !== 'CERRADA' && this.requisicion.estado !== 'RECHAZADA' &&
                      record.estado !== 'CONTRATADO' && this.requisicion.status !== this.status.REQUISICIONES_ETAPA_FINALIZADA &&
                      (this.isHRReq || (UserUtil.isInRol('RCDReq') && (this.requisicion.estado === 'LIDER TH' ||
                        this.requisicion.estado === 'COORDINADOR DE SELECCIÓN 2' ||
                        this.requisicion.estado === 'GERENCIA DE PRODUCCIÓN' ||
                        this.requisicion.estado === 'GERENCIA GENERAL' ||
                        this.requisicion.estado === 'ABIERTA')) ||
                        (UserUtil.isInRol('ContraReq') && (this.requisicion.estado === 'ABIERTA')))
                  }
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  icon: 'delete',
                  props: {size: 'small', type: 'link', icon: 'delete', style: 'color:red;'},
                  fnVisible: (record) => {
                    return this.requisicion.estado !== 'CERRADA' && this.requisicion.estado !== 'RECHAZADA' &&
                      record.estado !== 'CONTRATADO' && this.requisicion.status !== this.status.REQUISICIONES_ETAPA_FINALIZADA &&
                      (this.isHRReq || (UserUtil.isInRol('RCDReq') && (this.requisicion.estado === 'LIDER TH' ||
                        this.requisicion.estado === 'COORDINADOR DE SELECCIÓN 2' ||
                        this.requisicion.estado === 'GERENCIA DE PRODUCCIÓN' ||
                        this.requisicion.estado === 'GERENCIA GENERAL')))
                  }
                },
                {
                  name: 'formulario',
                  text: 'Formulario',
                  icon: 'form',
                  props: {size: 'small', type: 'link', icon: 'form', style: 'color:blue;'},
                  fnVisible: (record) => {
                    return !JsUtils.isEmpty(record.id_forms_fillout) && this.requisicion.estado !== 'CERRADA' &&
                      this.requisicion.estado !== 'RECHAZADA' && record.estado === 'APLICA' &&
                      record.estado !== 'CONTRATADO' && this.requisicion.status !== this.status.REQUISICIONES_ETAPA_FINALIZADA &&
                      (this.isHRReq ||
                        (UserUtil.isInRol('RCDReq') && (this.requisicion.estado === 'LIDER TH' ||
                          this.requisicion.estado === 'COORDINADOR DE SELECCIÓN 2' ||
                          this.requisicion.estado === 'GERENCIA DE PRODUCCIÓN' ||
                          this.requisicion.estado === 'GERENCIA GENERAL')) ||
                        (UserUtil.isInRol('ContraReq') && (this.requisicion.estado === 'ABIERTA')) ||
                        this.requisicion.estado === UserUtil.getConfigValue('REQ_ESTADO_ABIERTA_MOSTRAR_DESCRIPCION'))
                  }
                },
                {
                  name: 'contratar',
                  text: 'Contratar',
                  props: {size: 'small', type: 'link', icon: 'safety-certificate', style: 'color:green;'},
                  fnVisible: (record) => {
                    return (this.soyClienteAspaen === 'SI' && record.estado === 'APLICA' &&
                            this.requisicion.estado !== 'CERRADA' && this.requisicion.estado !== 'RECHAZADA' &&
                            UserUtil.isInRol('RHandReq')) ||
                         (this.soyClienteAspaen === 'NO' &&
                           ((record.estado === 'APLICA') || (record.estado === 'ASCENSO') || ((UserUtil.isInRol('ContraReq') && (this.requisicion.estado === 'ABIERTA') && (record.estado === 'PENDIENTE CONFIRMACIÓN INGRESO')))) &&
                           this.requisicion.estado !== 'CERRADA' &&
                           this.requisicion.estado !== 'RECHAZADA' &&
                           (this.isHRReq || UserUtil.isInRol('Aliados') || (UserUtil.isInRol('ContraReq') && (this.requisicion.estado === 'ABIERTA'))) &&
                           (this.requisicion.status !== this.status.REQUISICIONES_ETAPA_FINALIZADA ||
                               this.requisicion.estado === UserUtil.getConfigValue('REQ_ESTADO_ABIERTA_MOSTRAR_DESCRIPCION')))
                  }
                },
                {
                  name: 'clear_fills',
                  text: 'Vaciar formulario',
                  props: {size: 'small', type: 'link', icon: 'close-square', style: 'color:red;'},
                  fnVisible: (record) => {
                    return !JsUtils.isEmpty(record.id_forms_fillout) && this.requisicion.estado !== 'CERRADA' &&
                      this.requisicion.estado !== 'RECHAZADA' && record.estado === 'APLICA' &&
                      record.estado !== 'CONTRATADO' && this.requisicion.status !== this.status.REQUISICIONES_ETAPA_FINALIZADA &&
                      (this.isHRReq || (UserUtil.isInRol('RCDReq') && (this.requisicion.estado === 'LIDER TH' ||
                        this.requisicion.estado === 'COORDINADOR DE SELECCIÓN 2' ||
                        this.requisicion.estado === 'GERENCIA DE PRODUCCIÓN' ||
                        this.requisicion.estado === 'GERENCIA GENERAL' ||
                        this.requisicion.estado === 'ABIERTA')) || (UserUtil.isInRol('ContraReq') && (this.requisicion.estado === 'ABIERTA')))
                  }
                },
                {
                  name: 'ver_evaluadores',
                  text: 'Evaluadores',
                  props: {size: 'small', type: 'link', icon: 'team', style: 'color:black;'},
                  fnVisible: (record) => {
                    return this.$getConfigValue('REQUISICIONES_VALIDACION_ENCUESTA', 'NO') === 'SI'
                  }
                },
                {
                  name: 'consultarFormulario',
                  text: 'Consultar Formulario',
                  icon: 'form',
                  props: {size: 'small', type: 'link', icon: 'form', style: 'color:blue;'},
                  fnVisible: (record) => {
                    return !JsUtils.isEmpty(record.id_forms_fillout) && record.estado === 'CONTRATADO' &&
                      (this.isHRReq || (UserUtil.isInRol('RCDReq') && (this.requisicion.estado === 'LIDER TH' ||
                        this.requisicion.estado === 'COORDINADOR DE SELECCIÓN 2' ||
                        this.requisicion.estado === 'GERENCIA DE PRODUCCIÓN' ||
                        this.requisicion.estado === 'GERENCIA GENERAL')))
                  }
                }
              ]
            },
            tableConfig: {
              rowKey: 'id_person_reg'
            },
            customSlots: ['estadoRenderer', 'customAction', 'progresoSlot', 'notasSlot']
          },
          parentData: {
            req_id: this.requisicion.req_id
          },
          actions: [
            {
              name: 'registrar',
              text: 'Registrar',
              icon: 'plus',
              permisos: [],
              props: {},
              fnVisible: () => {
                return this.requisicion.estado !== 'CERRADA' &&
                  this.requisicion.estado !== 'RECHAZADA' &&
                  this.requisicion.status !== this.status.REQUISICIONES_ETAPA_FINALIZADA &&
                  (this.isHRReq || (UserUtil.isInRol('RCDReq') && (this.requisicion.estado === 'LIDER TH' ||
                    this.requisicion.estado === 'COORDINADOR DE SELECCIÓN 2' ||
                    this.requisicion.estado === 'GERENCIA DE PRODUCCIÓN' ||
                    this.requisicion.estado === 'GERENCIA GENERAL' ||
                    this.requisicion.estado === 'ABIERTA')))
              }
            },
            {
              name: 'cargar',
              text: 'Cargar Candidatos',
              icon: 'plus',
              permisos: [],
              props: {},
              fnVisible: () => {
                return this.requisicion.estado !== 'CERRADA' &&
                  this.requisicion.estado !== 'RECHAZADA' &&
                  this.requisicion.status !== this.status.REQUISICIONES_ETAPA_FINALIZADA &&
                  (this.isHRReq || (UserUtil.isInRol('RCDReq') && (this.requisicion.estado === 'LIDER TH' ||
                    this.requisicion.estado === 'COORDINADOR DE SELECCIÓN 2' ||
                    this.requisicion.estado === 'GERENCIA DE PRODUCCIÓN' ||
                    this.requisicion.estado === 'GERENCIA GENERAL')))
              }
            },
            {
              name: 'contratar_seleccionados',
              text: 'Contratar seleccionados',
              icon: 'check',
              permisos: [],
              props: {},
              fnVisible: () => {
                return this.requisicion.estado !== 'CERRADA' && this.requisicion.estado !== 'RECHAZADA' &&
                  this.requisicion.status !== this.status.REQUISICIONES_ETAPA_FINALIZADA &&
                  ((this.soyClienteAspaen === 'SI' && UserUtil.isInRol('RHandReq')) ||
                    (this.soyClienteAspaen === 'NO' &&
                      (this.isHRReq || (UserUtil.isInRol('ContraReq') && (this.requisicion.estado === 'ABIERTA')))
                    )
                  ) && this.mostrar_contratacion_masiva
              }
            }
          ]
        },
        candidatoModal: {
          loading: false,
          visible: false,
          error: false,
          mensajeError: '',
          motivoSolicitudSeleccionado: {},
          ocupanteAntSeleccionado: {},
          fiOptions: {
            'label-col': {span: 8},
            'wrapper-col': {span: 16},
            'has-feedback': true
          },
          estado_request: {h_lookup_type: 'ESTADO_SELECCION', use_code: true},
          form: undefined,
          candidatoSeleccionado: {}
        },
        messages: [],
        selected: false,
        key: 0,
        status: {
          REQUISICIONES_ETAPA_INICIADA: this.$getConfigValue('REQUISICIONES_ETAPA_INICIADA', '00'),
          REQUISICIONES_ETAPA_ABIERTA: this.$getConfigValue('REQUISICIONES_ETAPA_ABIERTA', '00'),
          REQUISICIONES_ETAPA_FINALIZADA: this.$getConfigValue('REQUISICIONES_ETAPA_FINALIZADA', '00'),
          REQUISICIONES_ETAPA_CERRADA: this.$getConfigValue('REQUISICIONES_ETAPA_CERRADA', '00'),
          REQUISICIONES_ETAPA_RECHAZADA: this.$getConfigValue('REQUISICIONES_ETAPA_RECHAZADA', '00')
        },
        mostrar_contratacion_masiva: this.$getConfigValue('MOSTRAR_CONTRATACION_MASIVA_DETALLE_CANDIDATOS', 'SI') === 'SI',
        soyClienteAspaen: this.$getConfigValue('REQUISICIONES_CLIENTE_ASPAEN', 'NO')
      }
    },
    props: ['requisicion'],
    beforeMount () {
      this.candidatoModal.form = this.$form.createForm(this, {
        name: 'registrarPersonReq'
      })
      this.registerDecorators()
    },
    mounted () {
      this.httpClient = new HttpUtil('gestion_humana/persona_requisiciones')
      this.setAllowSelect()
    },
    methods: {
      reloadData (value) {
        if (value) {
          this.$refs.masterComponent.$refs.datatable.loadData()
        }
      },
      masterAction (action) {
        switch (action.action) {
          case 'registrar':
            this.isedit = false
            this.candidatoModal.candidatoSeleccionado = {}
            this.candidatoModal.form.resetFields()
            this.mostrarModalRegistrar()
            break
          case 'modificar':
            this.isedit = true
            this.mostrarModalRegistrar()
            this.registerDecorators()
            this.candidatoModal.form.setFieldsValue({
              id_person: action.record.id_person,
              initial_date: action.record.initial_date,
              status: action.record.status,
              reingreso_check: action.record.reingreso === 'S',
              observacion: action.record.observacion
            })
            this.$refs.empDropdown && this.$refs.empDropdown.handleSearch(action.record.id_person)
            this.candidatoModal.candidatoSeleccionado = action.record
            break
          case 'cargar':
            this.isedit = false
            this.modalCargarCandidatosVisible = true
            break
          case 'formulario':
            this.isedit = false
            let routeData = this.$router.resolve({
              name: 'FormFillout',
              query: {fillOutId: action.record.id_forms_fillout}
            })
            window.open(routeData.href, '_blank')
            break
          case 'consultarFormulario':
            this.isedit = false
            let route = this.$router.resolve({
              name: 'ConsultarFormFillout',
              query: {fillOutId: action.record.id_forms_fillout}
            })
            window.open(route.href, '_blank')
            break
          case 'clear_fills':
            this.isedit = false
            this.$confirm({
              title: 'Confirmación',
              content: '¿Está seguro que desea elminar los formularios?',
              okText: 'Si',
              okType: 'danger',
              cancelText: 'No',
              onOk: () => {
                return new Promise((resolve, reject) => {
                  this.httpClient.getInstance().delete('gestion_humana/requisiciones/clear_fillouts/' + action.record.id_forms_fillout)
                    .then((response) => {
                      Mensajes.success('Correcto', 'Proceso realizado exitosamente.')
                      this.refreshTable()
                      this.$refs.masterComponent.$refs.datatable.loadData() // cambio
                      resolve()
                    })
                    .catch((error) => {
                      Mensajes.error('Error', 'No fue posible realizar la solicitud.')
                      reject(error)
                    })
                })
              },
              onCancel () {}
            })
            break
          case 'contratar':
            this.isedit = false
            // eslint-disable-next-line no-unused-vars
            var mensaje = ''
            if (action.record.notas === 'VETO') {
              mensaje = '¿Está seguro que desea continuar?, Esta persona se encuentra VETADA y este proceso es complejo de reversar.'
            } else {
              mensaje = '¿Está seguro que desea continuar?, Este proceso es complejo de reversar.'
            }
            this.$confirm({
              title: 'Confirmación',
              content: mensaje,
              okText: 'Si',
              okType: 'danger',
              cancelText: 'No',
              onOk: () => {
                return new Promise((resolve, reject) => {
                  this.httpClient.getInstance().post('gestion_humana/requisiciones/contratar', {
                    id_person_reg: action.record.id_person_reg
                  })
                    .then((response) => {
                      if (parseInt(response.data.resultado) === 2) {
                        Mensajes.success('Correcto', 'Proceso realizado exitosamente.')
                        this.refreshTable()
                        this.$refs.masterComponent.$refs.datatable.loadData() // cambio
                        resolve()
                      } else {
                        Mensajes.error('Error', response.data.mensaje)
                        reject(response.data.mensaje)
                      }
                    })
                    .catch((error) => {
                      Mensajes.error('Error', 'No fue posible realizar la solicitud.')
                      reject(error)
                    })
                })
              },
              onCancel () {}
            })
            break
          case 'contratar_seleccionados':
            this.isedit = false
            if (!this.$isEmpty(this.detalleCandidato.tableSetup.selectedRows)) {
              this.$confirm({
                title: 'Confirmación',
                content: this.mensaje1,
                okText: 'Si',
                okType: 'danger',
                cancelText: 'No',
                onOk: () => {
                  return new Promise((resolve, reject) => {
                    this.messages = []
                    this.httpClient.getInstance().post('gestion_humana/requisiciones/contratar_seleccionados', {
                      person_reg: this.detalleCandidato.tableSetup.selectedRows,
                      selected: this.selected,
                      ...this.requestData
                    })
                      .then((response) => {
                        this.messages = response.data.messages
                        if (this.messages.length === 0) {
                          Mensajes.success('Correcto', 'La contratación masiva fue exitosa.')
                        }
                        this.refreshTable()
                        resolve()
                      })
                      .catch((error) => {
                        Mensajes.error('Error', 'No fue posible realizar la solicitud.')
                        reject(error)
                      })
                  })
                },
                onCancel () {}
              })
            } else {
              Mensajes.error('Debes de seleccionar al menos un candidato.')
            }
            break
          case 'ver_evaluadores':
            this.isedit = false
            if (!this.$isEmpty(action.record)) {
              this.id_person_reg = action.record.id_person_reg
              this.nombre_evaluado = action.record.name
              this.id_person = action.record.id_person
            }
            break
        }
      },
      confirmarModalRegistrar (e) {
        e.preventDefault()
        this.candidatoModal.form.validateFields((err, values) => {
          if (!err) {
            this.candidatoModal.loading = true
            this.candidatoModal.error = false
            let request = {id_req: this.requisicion.req_id, reingreso: values.reingreso_check ? 'S' : 'N', ...values}

            if (JsUtils.isEmpty(this.candidatoModal.candidatoSeleccionado)) {
              this.httpClient.create(request, this.manejaOk, this.manejaError).then(() => {
                this.candidatoModal.loading = false
              })
            } else {
              this.httpClient.update({id: this.candidatoModal.candidatoSeleccionado.id_person_reg, ...request}, this.manejaOk, this.manejaError).then(() => {
                this.candidatoModal.loading = false
              })
            }
          }
        })
      },
      manejaOk (response) {
        this.candidatoModal.error = false
        this.candidatoModal.loading = false
        this.candidatoModal.visible = false
        this.candidatoModal.form.resetFields()
        this.refreshTable()
      },
      manejaError (error) {
        this.candidatoModal.loading = false
        this.candidatoModal.error = true
        this.candidatoModal.mensajeError = error && error.response && error.response.data && error.response.data.message
      },
      mostrarModalRegistrar () {
        this.candidatoModal.visible = true
        this.candidatoModal.loading = false
        this.candidatoModal.error = false
        this.candidatoModal.mensajeError = ''
      },
      cancelModalRegistrar () {
        if (this.candidatoModal.loading) return
        this.candidatoModal.visible = false
        this.candidatoModal.loading = false
        this.candidatoModal.error = false
        this.candidatoModal.mensajeError = ''
      },
      refreshTable () {
        this.$refs.masterComponent.$refs.datatable.loadData()
      },
      registerDecorators () {
        this.candidatoModal.form.getFieldDecorator('id_person_reg')
        this.candidatoModal.form.getFieldDecorator('id_person', {rules: [{required: true, message: 'Valor requerido'}]})
        this.candidatoModal.form.getFieldDecorator('initial_date', {rules: [{required: true, message: 'Valor requerido'}]})
        this.candidatoModal.form.getFieldDecorator('status', {rules: [{required: true, message: 'Valor requerido'}]})
        this.candidatoModal.form.getFieldDecorator('reingreso_check', {valuePropName: 'checked'})
        this.candidatoModal.form.getFieldDecorator('observacion', {trigger: 'change'})
      },
      selectAll (selected) {
        this.selected = selected
      },
      getColor (record) {
        return record.hasOwnProperty('color') ? record.color : 'blue'
      },
      setAllowSelect () {
        if (this.mostrar_contratacion_masiva) {
          this.detalleCandidato.tableSetup.allowSelect = !(this.requisicion.status === this.status.REQUISICIONES_ETAPA_CERRADA ||
            this.requisicion.status === this.status.REQUISICIONES_ETAPA_FINALIZADA ||
            this.requisicion.status === this.status.REQUISICIONES_ETAPA_RECHAZADA ||
            ((UserUtil.isInRol('RCDReq') && (this.requisicion.estado === 'LIDER TH' ||
              this.requisicion.estado === 'COORDINADOR DE SELECCIÓN 2' ||
              this.requisicion.estado === 'GERENCIA DE PRODUCCIÓN' ||
              this.requisicion.estado === 'GERENCIA GENERAL')))
          )
          if (this.$getConfigValue('OBTENER_CANDIDATOS_VETADOS', 'NO') === 'SI') {
            this.getCantidadVetos()
          }
        } else {
          this.detalleCandidato.tableSetup.allowSelect = false
        }
        this.key++
      },
      getCantidadVetos () {
        this.httpClient.getInstance().post('gestion_humana/persona_requisiciones/cantidad_vetos/' + this.requisicion.req_id)
          .then(response => {
            if (response.data === 0) {
              this.mensaje1 = '¿Está seguro que desea continuar?, Este proceso es complejo de reversar.'
            } else {
              this.mensaje1 = '¿Está seguro que desea continuar?, ' +
                // 'Hay en total ' + response.data + ' personas VETADAS. ' +
                'Este proceso es complejo de reversar y puede tener seleccionadas personas que estan VETADAS.'
            }
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posble obtener la cantidad de vetados')
          })
      }
    },
    computed: {
      requestData () {
        return {'id_req': this.requisicion.req_id}
      },
      isHRReq () {
        return UserUtil.isInRol('HRReq')
      }
    },
    watch: {
      'requisicion.req_id': function () {
        this.setAllowSelect()
      }
    }
  }
</script>

<style>
  .scroll-text {
    text-align: justify;
    text-justify: inter-word;
    max-height: 200px !important;
    overflow-y: auto
  }
</style>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GestionHumana/Requisiciones/DetalleDeCandidatos.vue